import React from 'react';
import { useSelector } from 'react-redux';

import EventListCard from './EventListCard.jsx';

const LastEvent = () => {
    const lastEvent = useSelector(state => state.events.eventList[0]);
    if (lastEvent) {
        return (
            <div style={{ marginTop: '10px', marginBottom: '3px' }}>
                <EventListCard
                    eventId={lastEvent}
                    key={lastEvent}
                    index={-1}
                />
            </div>

        );
    } else {
        return null;
    }

}

export default React.memo(LastEvent);
